import { useEffect, useRef, useState } from "react";
interface CaptchaApi {
  render(container: HTMLElement, options: { sitekey: string; hl: string; callback: (token: string) => void }): number;
  destroy(id: number): void;
  subscribe(id: number, event: string, callback: () => void): () => void;
}
declare global { interface Window { smartCaptcha?: CaptchaApi; } }
let loading: Promise<void> | null = null;
function loadCaptcha() {
  if (window.smartCaptcha) return Promise.resolve();
  if (loading) return loading;
  loading = new Promise<void>((resolve, reject) => {
    const script = document.createElement("script");
    script.src = "https://smartcaptcha.cloud.yandex.ru/captcha.js?render=onload";
    script.async = true;
    script.onload = () => window.smartCaptcha ? resolve() : reject(new Error("captcha unavailable"));
    script.onerror = () => { script.remove(); loading = null; reject(new Error("captcha unavailable")); };
    document.head.appendChild(script);
  });
  return loading;
}
export function RegistrationCaptcha({ siteKey, onToken, attempt }: { siteKey: string; onToken: (token: string) => void; attempt: number }) {
  const container = useRef<HTMLDivElement>(null);
  const [error, setError] = useState(false);
  const [retry, setRetry] = useState(0);
  useEffect(() => {
    let disposed = false;
    let widget: number | undefined;
    const unsubscribe: (() => void)[] = [];
    onToken(""); setError(false);
    void loadCaptcha().then(() => {
      if (disposed || !container.current || !window.smartCaptcha) return;
      widget = window.smartCaptcha.render(container.current, { sitekey: siteKey, hl: "ru", callback: onToken });
      unsubscribe.push(window.smartCaptcha.subscribe(widget, "token-expired", () => onToken("")));
      for (const event of ["network-error", "javascript-error"]) unsubscribe.push(window.smartCaptcha.subscribe(widget, event, () => { onToken(""); setError(true); }));
    }).catch(() => { if (!disposed) setError(true); });
    return () => { disposed = true; unsubscribe.forEach(fn => fn()); if (widget !== undefined) window.smartCaptcha?.destroy(widget); };
  }, [siteKey, onToken, attempt, retry]);
  return <div><div ref={container} />{error && <p role="alert" className="mt-2 text-sm text-destructive">Не удалось загрузить проверку. <button type="button" className="underline" onClick={() => { loading = null; setRetry(n => n + 1); }}>Повторить</button></p>}</div>;
}
